<template>
  <div class="fee-invoice">
    <el-tabs class="fee-tabs" v-model="activeName">
      <el-tab-pane label="开票申请" name="done">
        <fee-do-list @switchTab="(tab) => activeName = tab" v-if="activeName === 'done'"></fee-do-list>
      </el-tab-pane>
      <el-tab-pane label="未开票订单" name="undo">
        <fee-undo-list v-if="activeName === 'undo'"></fee-undo-list>
      </el-tab-pane>
    </el-tabs>
    <fee-tax-info class="manage-btn"></fee-tax-info>
  </div>
</template>
<script>
import FeeDoList from "./components/fee-do-list.vue";
import FeeUndoList from "./components/fee-undo-list.vue";
import FeeTaxInfo from "./components/fee-tax-manage.vue";
export default {
  components: { FeeDoList, FeeUndoList, FeeTaxInfo },
  data() {
    return {
      activeName: "done"
    }
  },
}
</script>
<style lang="scss" scoped>
.fee-invoice {
  position: relative;
  .manage-btn {
    position: absolute;
    right: 20px;
    top: 20px;
  }
  .fee-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
    ::v-deep {
      .el-tabs__content {
        flex: 1;
        display: flex;
      }
      .el-tab-pane {
        flex: 1;
        display: flex;
        width: 100%;
      }
    }
  }
}
</style>